<script setup lang="ts">

</script>

<template>
  <footer>
    <div class="links">
      <ul>
        <li>
          <h3>Onze app</h3>
        </li>
        <li>
          <a href="/onze-app"><i class="fa-solid fa-tablet-screen-button"></i> Onze app</a>
        </li>
        <li>
          <a href="/"><i class="fa-solid fa-house"></i> Home</a>
        </li>
        <li>
          <a href="/privacy-verklaring"><i class="fa-solid fa-shield-halved"></i> Privacyverklaring</a>
        </li>
      </ul>
      <ul>
        <li>
          <h3>De hartstichting</h3>
        </li>
        <li>
          <a href="https://www.hartstichting.nl/">Hartstichting</a>
        </li>
        <li>
          <a href="https://www.hartstichting.nl/over-ons/disclaimer">Disclaimer</a>
        </li>
        <li>
          <a href="https://www.hartstichting.nl/over-ons/privacyverklaring"><i class="fa-solid fa-shield-halved"></i> Privacyverklaring</a>
        </li>
        <li>
          <a href="https://www.youtube.com/user/dehartstichting"><i class="fa-brands fa-youtube"></i> Youtube</a>
        </li>
      </ul>
      <ul>
        <li>
          <h3>Hogeschool Leiden</h3>
        </li>
        <li>
          <a href="https://www.hsleiden.nl/en"><i class="fa-solid fa-graduation-cap"></i> Hogeschool Leiden</a>
        </li>
        <li>
          <a href="https://www.youtube.com/@hogeschoolleiden"><i class="fa-brands fa-youtube"></i> Youtube</a>
        </li>
        <li>
          <a href="https://www.linkedin.com/school/hogeschool-leiden"><i class="fa-brands fa-linkedin"></i> LinkedIn</a>
        </li>
      </ul>
      <ul>
        <li>
          <img src="@/assets/images/g8.png" alt="logo">
        </li>
      </ul>
    </div>
    <div class="copyright">
      &copy; 2025 Ervaar je hartslag. Alle rechten voorbehouden.
    </div>
  </footer>
</template>

<style scoped>
footer {
  margin: 4rem;
  border-radius: var(--border-radius);
  background-color: var(--color-gray-light);
  padding: 1.5rem;
}

.copyright {
  text-align: center;
}

ul {
  list-style-type: none;
  padding: 0;
  margin-left: auto;
  margin-right: auto;
}

.links {
  display: grid;
  justify-content: space-evenly;
  margin-bottom: 2rem;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

h3 {
  margin-bottom: 8px;
  margin-top: 0;
  color: var(--color-text-white-primary);
}

li {
  margin: 4px;
}

img {
  margin: 4px;
  height: 6rem;
}

@media only screen and (max-width: 800px) {
  .links {
    grid-template-columns: 1fr 1fr;
  }

  footer {
    margin: 0;
    border-radius: var(--border-radius) var(--border-radius) 0 0;
  }
}
</style>